export default __webpack_public_path__ + "static/media/rupee-symbol.4cf7dc5f.svg";